module.exports = __webpack_public_path__ + "orange.jpg?b1ba1bceae5c94bf0bb76c9bd53c1c67";